import { registerFeatureWithDescription } from "lib/features"

export const FEATURE_FLAG_TESTING_TOOLS = registerFeatureWithDescription({
    numericalId: 2501,
    id: "testing-tools",
    name: "Testing Tools",
    internalUseOnly: true,
    descriptionLines: [
        "Enables the Testing Tools section in the left sidebar. Gate for QA/dev tools that should not be visible in production.",
    ],
})
